import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MeasureService } from '../measure.service';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-modal-access-other-report',
  templateUrl: './modal-access-other-report.component.html',
  styleUrls: ['./modal-access-other-report.component.scss']
})
export class ModalAccessOtherReportComponent implements OnInit {

  modalData: any;
  otherReport = []

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalAccessOtherReportComponent>,
    private measureService: MeasureService,
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
    this.getOtherReport();
    // console.log(this.modalData.MEASURE_ID);
  }

  getOtherReport() {
    this.measureService.getShareUserByMeasure(this.modalData.MEASURE_ID).pipe(
      map(res => {
        if(res.success) {
          // console.log(res)
          this.otherReport = res.result;
        }
      }),
      catchError(err=> {
        alert('ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง');
        window.location.reload();
        return of(false);
      })
    ).subscribe();
  }

  selectReport(report) {
    // console.log(report);
    const response = {
      status: true,
      value: 'selectReport',
      report: report,
    }

    this.dialogRef.close(response);
  }

  addEmail() {
    const response = {
      status: true,
      value: 'email'

    }

    this.dialogRef.close(response);
  }

  closeModal() {
    const response = {
      status: false,
    }

    this.dialogRef.close(response);
  }

}
